import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { createSessionToken } from '@pkgs/api/utils';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { getPlaceDetailsV2, type Language, type PlaceDetails } from '@generated/search-bff';

export type GetLocationDetailsOptions = {
  language: Language;
  sessionToken?: string;
};

/**
 * Fetch detailed location information for a given place ID using the `/api/v2/autosuggestion/details` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/autosuggestion/getLocationDetails Search API Documentation}
 */
export async function getLocationDetails(
  placeId: string,
  { language, sessionToken }: GetLocationDetailsOptions,
  apiConfig: ApiConfig,
): Promise<ApiResult<PlaceDetails>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'getLocationDetails');
    const result = await getPlaceDetailsV2(
      {
        placeId,
        language,
        sessionToken: sessionToken ?? createSessionToken(),
      },
      _apiConfig,
    );

    return {
      status: 'success',
      data: result,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
